// Functions.
// -----------------------------------------------------------------------------
export const pick = (object, prop) => {
    const keys = prop.split('.');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let value = object;
    keys.forEach((key) => {
        if (typeof value === 'undefined' || value === null) {
            return undefined;
        }
        value = value[key];
    });
    return value;
};
//# sourceMappingURL=object.utils.js.map